import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const OnlineTemplateManegementStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */
  /* &.card-template {
    .form-group {
      label {
        max-width: 125px;
      }
    }
  } */

  /* Modifiers
  ------------------------------- */
  /* file .attached-file-list */
  .attached-list {
    display: table;
    table-layout: fixed;
    width: 100%;
    /* margin-top: 10px; */

    .file-link {
      display: flex;
      align-items: center;
      border-radius: 6px;
      text-decoration: none;
      margin-bottom: 10px;
      position: relative;
      cursor: pointer;
      justify-content: end;
      font-weight: 500;
      color: #6c63ff;
      column-gap: 10px;
    }

    .file-link-wrapper {
      display: flex;
      align-items: center;
      text-decoration: none;
      position: relative;
      cursor: pointer;
      justify-content: end;
      font-weight: 500;
      color: #6c63ff;
      border-radius: 6px;
      /* column-gap: 10px; */
    }

    a {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      background-color: #f7f7f7;
      border: 1px solid #cccccc;
      padding: 7px 40px;
      border-radius: 6px;
      position: relative;

      &::before {
        content: '';
        display: block;
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAARCAYAAADtyJ2fAAAABHNCSVQICAgIfAhkiAAAANVJREFUKFPtkrFtAlEQRN8ITGpKwJkDTpRgqMB0AM7QEZgW6IAALoYOoAJDDUcBVwISoWXGMvjQcTpAZAT8aP/+eX9GqxWZE4SeI96zvb/aoqUdnTjSR/qmrKgeeinxVgiaL8w0hW8D9/YHWPXQI0RDZmboFjl+//BSLlNLk6zHWiro2/uPzBBoFoH56PFEeoD5qfzf72M4VYnPMwmP7ZOomAQx2D6xSkbaXIOPC3BJaLNaR2pmNQpCbxDPFx3MIo7UPgFfe66VSrRlqkWwINlWmOfj/wIr+oASqg1wHwAAAABJRU5ErkJggg==);
        width: 13px;
        height: 16px;
        position: absolute;
        left: 20px;
        top: 12px;

        @media (max-width: 1280.98px) {
          top: 9px;
        }
      }
    }

    .button {
      border: 0;
      text-decoration: underline;
      color: #6c63ff;
      background-color: transparent;
      font-weight: normal;
      display: inline-flex;
      width: auto;
      height: auto;
      border-radius: 0;
      position: absolute;
      right: 10px;
    }
  }

  .btn-icon {
    .image-control {
      width: 13px;
      height: 12px;
    }
  }

  .bottom-template-wrapper {
    column-gap: 10px;
  }

  .form-group {
    max-width: none;

    > label {
      padding-right: 1rem;
      margin-right: 0 !important;
    }

    .input-control {
      max-width: none;
    }

    .input-textarea-control {
      max-width: none;
    }

    .select-control {
      max-width: none;
    }

    .message {
      opacity: 1;
    }
  }

  .card {
    background-color: ${VARIABLES.COLORS.WHITE};
    border-radius: ${VARIABLES.BORDER_RADIUSES.SM};
  }

  .card-group {
    border: 1px solid ${VARIABLES.COLORS.BLUE_11};
    border-radius: ${VARIABLES.BORDER_RADIUSES.TN};
    padding: 1rem;
  }

  .delete-icon {
    width: 14px;
  }

  .switch-wrapper {
    + label {
      margin-left: 1rem;
      color: ${VARIABLES.COLORS.GRAY_5};
    }
  }

  hr {
    margin-bottom: 1rem;
    border-color: ${VARIABLES.COLORS.GRAY_2};

    &.blue {
      border-color: ${VARIABLES.COLORS.BLUE_11};
    }
  }

  /* not find props react select */
  .is-error {
    .css-1q0hakr-control {
      border-color: #dd4534;
    }
  }

  /* Media queries
  ------------------------------- */
  @media all and (min-width: 1400px) {
    max-width: 1200px;
  }
`
